// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"d51015afe496d02f5fa1","5338":"5c78209a44d4b6932a7f"}[chunkId] + ".js";
};